import ApiRequest from '../request/ApiRequest'

export default class Contact {
  constructor() {
    this.ApiRequest = new ApiRequest()
  }

  async send(data) {
    try {
      const res = await this.ApiRequest.post('contacts', data)
      return res
    } catch (error) {
      return error.response
    }
  }
}
